<template>
  <v-dialog
    v-if="predictions?.length"
    v-model="isDialogOpen"
    scrollable
    max-width="45rem"
  >
    <template #activator="{ on: dialogOn, attrs: dialogAttrs }">
      <v-tooltip
        right
        v-bind="defaultVTooltipProps"
      >
        <template #activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <v-btn
            v-bind="{ ...tooltipAttrs, ...dialogAttrs }"
            v-on="{ ...tooltipOn, ...dialogOn }"
            depressed
            rounded
            x-small
            color="primary"
            aria-label="Show in cards"
          >
            <v-icon small>mdi-open-in-new</v-icon>
          </v-btn>
        </template>
        <span>Show in cards</span>
      </v-tooltip>
    </template>

    <v-card class="d-flex flex-column">
      <v-toolbar
        dark
        color="primary"
        dense
        class="pl-4 px-1"
      >
        <div
          class="w-100 d-flex flex-row align-items-center justify-content-between"
          style="gap: 1rem"
        >
          <v-toolbar-title>{{ chemical?.name }}</v-toolbar-title>

          <v-btn
            icon
            dark
            @click="isDialogOpen = false"
            aria-label="Close dialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-toolbar>

      <v-card-text class="p-2">
        <EpiSuiteDetailed
          :items="predictions"
          :card-elevation="2"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { defaultVTooltipProps } from '@/utils/defaultProps'
import EpiSuiteDetailed from './EpiSuiteDetailed.vue'

export default {
  name: 'EpiSuiteDetailDialog',
  components: { EpiSuiteDetailed },
  // NOTE: Do NOT declare a prop named "params" — ag-grid injects it on the component instance
  data() {
    return {
      isDialogOpen: false,
      defaultVTooltipProps,
      predictions: [],
    }
  },
  computed: {
    chemical() {
      return this.params.data?.chemical ?? null
    },
  },

  beforeMount() {
    this.predictions = this.params?.epiSuitePredictions
  },
}
</script>
